/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RecentCoursesRouteImport } from './routes/RecentCourses'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ApplyTailoringRouteImport } from './routes/apply-tailoring'
import { Route as AviationRouteImport } from './routes/aviation'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CorporateTrainingRouteImport } from './routes/corporate-training'
import { Route as EduadminRouteImport } from './routes/eduadmin'
import { Route as ItDetailsRouteImport } from './routes/it-details'
import { Route as ItTrainingRouteImport } from './routes/it-training'
import { Route as PlacementRouteImport } from './routes/placement'
import { Route as SkillsRouteImport } from './routes/skills'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecentCoursesRoute = RecentCoursesRouteImport.update({
  id: '/RecentCourses',
  path: '/RecentCourses',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyTailoringRoute = ApplyTailoringRouteImport.update({
  id: '/apply-tailoring',
  path: '/apply-tailoring',
  getParentRoute: () => rootRouteImport,
} as any)
const AviationRoute = AviationRouteImport.update({
  id: '/aviation',
  path: '/aviation',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CorporateTrainingRoute = CorporateTrainingRouteImport.update({
  id: '/corporate-training',
  path: '/corporate-training',
  getParentRoute: () => rootRouteImport,
} as any)
const EduadminRoute = EduadminRouteImport.update({
  id: '/eduadmin',
  path: '/eduadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const ItDetailsRoute = ItDetailsRouteImport.update({
  id: '/it-details',
  path: '/it-details',
  getParentRoute: () => rootRouteImport,
} as any)
const ItTrainingRoute = ItTrainingRouteImport.update({
  id: '/it-training',
  path: '/it-training',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacementRoute = PlacementRouteImport.update({
  id: '/placement',
  path: '/placement',
  getParentRoute: () => rootRouteImport,
} as any)
const SkillsRoute = SkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/RecentCourses': typeof RecentCoursesRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/apply-tailoring': typeof ApplyTailoringRoute
  '/aviation': typeof AviationRoute
  '/contact': typeof ContactRoute
  '/corporate-training': typeof CorporateTrainingRoute
  '/eduadmin': typeof EduadminRoute
  '/it-details': typeof ItDetailsRoute
  '/it-training': typeof ItTrainingRoute
  '/placement': typeof PlacementRoute
  '/skills': typeof SkillsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/RecentCourses': typeof RecentCoursesRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/apply-tailoring': typeof ApplyTailoringRoute
  '/aviation': typeof AviationRoute
  '/contact': typeof ContactRoute
  '/corporate-training': typeof CorporateTrainingRoute
  '/eduadmin': typeof EduadminRoute
  '/it-details': typeof ItDetailsRoute
  '/it-training': typeof ItTrainingRoute
  '/placement': typeof PlacementRoute
  '/skills': typeof SkillsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/RecentCourses': typeof RecentCoursesRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/apply-tailoring': typeof ApplyTailoringRoute
  '/aviation': typeof AviationRoute
  '/contact': typeof ContactRoute
  '/corporate-training': typeof CorporateTrainingRoute
  '/eduadmin': typeof EduadminRoute
  '/it-details': typeof ItDetailsRoute
  '/it-training': typeof ItTrainingRoute
  '/placement': typeof PlacementRoute
  '/skills': typeof SkillsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/RecentCourses'
    | '/about'
    | '/admin'
    | '/apply-tailoring'
    | '/aviation'
    | '/contact'
    | '/corporate-training'
    | '/eduadmin'
    | '/it-details'
    | '/it-training'
    | '/placement'
    | '/skills'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/RecentCourses'
    | '/about'
    | '/admin'
    | '/apply-tailoring'
    | '/aviation'
    | '/contact'
    | '/corporate-training'
    | '/eduadmin'
    | '/it-details'
    | '/it-training'
    | '/placement'
    | '/skills'
  id:
    | '__root__'
    | '/'
    | '/RecentCourses'
    | '/about'
    | '/admin'
    | '/apply-tailoring'
    | '/aviation'
    | '/contact'
    | '/corporate-training'
    | '/eduadmin'
    | '/it-details'
    | '/it-training'
    | '/placement'
    | '/skills'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RecentCoursesRoute: typeof RecentCoursesRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRoute
  ApplyTailoringRoute: typeof ApplyTailoringRoute
  AviationRoute: typeof AviationRoute
  ContactRoute: typeof ContactRoute
  CorporateTrainingRoute: typeof CorporateTrainingRoute
  EduadminRoute: typeof EduadminRoute
  ItDetailsRoute: typeof ItDetailsRoute
  ItTrainingRoute: typeof ItTrainingRoute
  PlacementRoute: typeof PlacementRoute
  SkillsRoute: typeof SkillsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/RecentCourses': {
      id: '/RecentCourses'
      path: '/RecentCourses'
      fullPath: '/RecentCourses'
      preLoaderRoute: typeof RecentCoursesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply-tailoring': {
      id: '/apply-tailoring'
      path: '/apply-tailoring'
      fullPath: '/apply-tailoring'
      preLoaderRoute: typeof ApplyTailoringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aviation': {
      id: '/aviation'
      path: '/aviation'
      fullPath: '/aviation'
      preLoaderRoute: typeof AviationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/corporate-training': {
      id: '/corporate-training'
      path: '/corporate-training'
      fullPath: '/corporate-training'
      preLoaderRoute: typeof CorporateTrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eduadmin': {
      id: '/eduadmin'
      path: '/eduadmin'
      fullPath: '/eduadmin'
      preLoaderRoute: typeof EduadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/it-details': {
      id: '/it-details'
      path: '/it-details'
      fullPath: '/it-details'
      preLoaderRoute: typeof ItDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/it-training': {
      id: '/it-training'
      path: '/it-training'
      fullPath: '/it-training'
      preLoaderRoute: typeof ItTrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/placement': {
      id: '/placement'
      path: '/placement'
      fullPath: '/placement'
      preLoaderRoute: typeof PlacementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skills': {
      id: '/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof SkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RecentCoursesRoute: RecentCoursesRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRoute,
  ApplyTailoringRoute: ApplyTailoringRoute,
  AviationRoute: AviationRoute,
  ContactRoute: ContactRoute,
  CorporateTrainingRoute: CorporateTrainingRoute,
  EduadminRoute: EduadminRoute,
  ItDetailsRoute: ItDetailsRoute,
  ItTrainingRoute: ItTrainingRoute,
  PlacementRoute: PlacementRoute,
  SkillsRoute: SkillsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
